import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../../components/loading/loading.component';
import { Bind } from 'primeng/bind';
import { CardModule } from 'primeng/card';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ApiService } from '../../_utils/api/api.service';
import { slugify } from '../../_utils/functions';
import { InsightService } from '../../_utils/insight/insight.service';
import { SeoService } from '../../_utils/seo/seo.service';

@Component({
    selector: 'app-locations',
    templateUrl: './locations.component.html',
    styleUrl: './locations.component.scss',
    imports: [CommonModule, LoadingComponent, TranslocoDirective, Bind, CardModule, TranslatePipe]
})
export class LocationsComponent {
  loading = signal(false);
  error: string = "";
  locations: any[] = [];
  data: any = null;

  constructor(private translocoService: TranslocoService, private insightService: InsightService, private seoService: SeoService, private apiService: ApiService, protected router: Router) { }

  ngOnInit(): void {
    this.loading.set(true);
    this.translocoService.selectTranslate('main_location').subscribe((main_location) => {
      this.apiService.getCompany().subscribe({
        next: (data) => {
          this.loading.set(false);

          const translatePipe = new TranslatePipe(this.translocoService);
          let description = translatePipe.transform(data.data.description);
          this.seoService.setSeo({
            title: data.data.denominazione,
            description: description || data.data.denominazione,
            image: data.data.image || data.data.logo,
            url: data.data.pwa_url + '/sedi'
          });

          if (typeof window === 'undefined')
            return;

          this.error = "";
          this.data = data.data;
          this.locations = [{ id: 1, title: main_location, address: data.data.address }, ...data.data.locations];
          this.insightService.send({
            event: 'open_page',
            event_name: 'sedi'
          });
        },
        error: (error) => {
          console.error(error);
          this.router.navigate(['error'], { queryParams: { message: error } });
        }
      });
    });
  }

  generateLocationUrl(location: any): string {
    return '/sede/' + (this.data.vanity_url ? slugify(location['title']) : location['id']);
  }
}
